import { useEffect, useState } from 'react';
import { resolveForceUpdate, wtnGetDeviceInfo, type ForceUpdateRequirement } from '@/utils';

/**
 * Resolves whether the WebToNative shell is running a build older than the
 * hardcoded latest. Null everywhere else: on the website, when the bridge is
 * silent, or when the payload cannot be trusted — the sheet must never appear
 * by accident.
 */
export function useForceAppUpdate(): ForceUpdateRequirement | null {
	const [requirement, setRequirement] = useState<ForceUpdateRequirement | null>(null);

	useEffect(() => {
		let cancelled = false;

		wtnGetDeviceInfo()
			.then((info) => {
				if (cancelled) return;
				const required = resolveForceUpdate(info);
				if (required) {
					const describe = (version: string, build: string | null) =>
						build ? `${version} (${build})` : version;
					console.warn(
						`[force-update] ${required.platform} ${describe(required.installed, required.installedBuild)} is older than ${describe(required.latest, required.latestBuild)}`
					);
				}
				setRequirement(required);
			})
			.catch(() => {
				// Fail open: a probe error is not evidence of an outdated build.
			});

		return () => {
			cancelled = true;
		};
	}, []);

	return requirement;
}
